module.exports = __webpack_public_path__ + "img/blog-list.91364bb2.png";